const allTopics = [
  { name: '暑期追剧指南', hot: true },
  { name: '高分电影推荐', hot: true },
  { name: '最新上映', hot: true },
  { name: '悬疑片爱好者', hot: false },
  { name: '日剧推荐', hot: false },
  { name: '韩剧热播', hot: true },
  { name: '国产剧必看', hot: false },
  { name: '动漫新番', hot: false },
  { name: '综艺笑点', hot: false },
  { name: '纪录片推荐', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            话题热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            大家都在讨论的影视话题，看看有哪些热门内容
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {allTopics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap no-underline ${
                topic.hot
                  ? 'bg-accent-500 text-white hover:bg-accent-600'
                  : 'bg-background-50 text-foreground-700 border border-background-200/70 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              <span>#</span>
              {topic.name}
              {topic.hot && (
                <span className="inline-flex items-center gap-0.5 text-xs bg-white/20 px-1.5 py-0.5 rounded-full ml-1">
                  <i className="ri-fire-line text-[10px]"></i>
                  HOT
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}